module.exports = __webpack_public_path__ + "img/map.86608a77.png";